var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-input',{attrs:{"placeholder":"業種","maxlength":"50","required":"","autocomplete":"off","autofocus":_vm.autofocus},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})}
var staticRenderFns = []

export { render, staticRenderFns }